import { MouseEvent } from "react";

interface CustomCheckboxProps {
    name: string;
    id?: string;
    checked?: boolean | null;
    /**
     * Partially selected - drawn as a dash instead of a tick. Used by tree pickers where a
     * parent covers only some of its children; ignored when checked is true.
     */
    indeterminate?: boolean;
    disabled?: boolean;
    variant?: "default" | "small";
    onChange: (isChecked: boolean) => void;
}

function CustomCheckbox({ name, id, checked, indeterminate = false, disabled = false, variant = "default", onChange }: CustomCheckboxProps) {

    function handleCheckboxClick(e: MouseEvent<HTMLDivElement, globalThis.MouseEvent>): void {
        if (!disabled) {
            onChange(!checked);
        }
    }

    function CheckIcon() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width={variant === "small" ? "10" : "14"} height={variant === "small" ? "8" : "11"} viewBox="0 0 14 11" fill="none">
                <path d="M13.7259 0.293692C13.8128 0.386553 13.8817 0.496869 13.9287 0.618319C13.9758 0.73977 14 0.86997 14 1.00146C14 1.13295 13.9758 1.26315 13.9287 1.38461C13.8817 1.50606 13.8128 1.61637 13.7259 1.70923L5.32756 10.7063C5.24088 10.7994 5.13791 10.8733 5.02454 10.9237C4.91117 10.9741 4.78964 11 4.6669 11C4.54416 11 4.42262 10.9741 4.30925 10.9237C4.19589 10.8733 4.09291 10.7994 4.00623 10.7063L0.273656 6.70761C0.098437 6.5199 0 6.2653 0 5.99984C0 5.73437 0.098437 5.47978 0.273656 5.29207C0.448876 5.10436 0.686525 4.9989 0.934322 4.9989C1.18212 4.9989 1.41977 5.10436 1.59499 5.29207L4.6669 8.585L12.4045 0.293692C12.4912 0.200596 12.5942 0.126734 12.7075 0.0763378C12.8209 0.0259413 12.9424 0 13.0652 0C13.1879 0 13.3095 0.0259413 13.4228 0.0763378C13.5362 0.126734 13.6392 0.200596 13.7259 0.293692Z" fill="var(--icon-text-color)" />
            </svg>
        );
    }

    function DashIcon() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width={variant === "small" ? "8" : "11"} height="2" viewBox="0 0 11 2" fill="none">
                <rect width="11" height="2" rx="1" fill="var(--icon-text-color)" />
            </svg>
        );
    }

    return (
        <div id={id ?? name} className={!disabled ? `checkbox ${variant}` : `checkbox-disabled ${variant}`} onClick={e => handleCheckboxClick(e)}>
            {checked ? <CheckIcon /> : indeterminate ? <DashIcon /> : null}
        </div>
    );
}

export default CustomCheckbox;